// CalcProfiler handles the profiling of calc events
export default class CalcProfiler {
  profile = this.newCalcProfile();

  // Generate a new calc profile object
  newCalcProfile() {
    return {
      stagesTotal: 19,
      calcStartTime: 0,
      currentStage: '',
      stageStartTime: 0,
      stageDurations: {},
      stagesEncountered: 0,
      percentCompleted: 0,
    }
  }

  // Clear calc profile
  clearCalcProfile() {
    this.profile = this.newCalcProfile();
  }

  // Update the calc profile
  updateCalcProfile(event) {
    if(this.profile.stagesEncountered > this.profile.stagesTotal) this.clearCalcProfile();
    if(!this.profile.currentStage) { // first stage
      this.profile.currentStage = event.msg.stage;
      this.profile.stageStartTime = event.timestamp;
      this.profile.calcStartTime = event.timestamp;
      this.profile.stagesEncountered++;
    } else {
      if (this.profile.stageDurations[this.profile.currentStage]) { // duplicate stage accumulate time
        this.profile.stageDurations[this.profile.currentStage] += event.timestamp - this.profile.stageStartTime;
      } else { // unique stages set initial time
        this.profile.stageDurations[this.profile.currentStage] = event.timestamp - this.profile.stageStartTime;
        this.profile.stagesEncountered++;
      }
      this.profile.currentStage = event.msg.stage;
      this.profile.stageStartTime = event.timestamp;
    }
    const tempCompleted = (this.profile.stagesEncountered / this.profile.stagesTotal) * 100 | 0;
    // don't allow the percentage to go backward
    if(tempCompleted > this.profile.percentCompleted) this.profile.percentCompleted = tempCompleted;
    // don't allow the percentage to go above 100
    if(this.profile.percentCompleted > 100) this.profile.percentCompleted = 100;
    console.log(`Timestamp: ${event.timestamp} - Event: ${event.msg.stage} - Completed: ${this.profile.percentCompleted}%`);
  }

  // Sync the calc detail with what is pulled from the server
  syncCalcDetail(property) {
    if (property.calcdetail && property.calcdetail.sectionComplete) {
      this.profile.stagesEncountered = property.calcdetail.sectionComplete + 1;
    }
  }

  // Calculate total time and print calc profile
  displayCalcProfile(event) {
    this.profile.stageDurations['calc_total'] = event.timestamp - this.profile.calcStartTime;
    console.log('Calc Profile', this.profile.stageDurations);
  }
}